const React = require("react")
const Product = ({ ...props }) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.14181 3.21879L21.2038 9.44439C21.5343 9.61494 21.7429 9.95474 21.7455 10.3266C21.748 10.6985 21.544 11.0411 21.2158 11.2161L16.714 13.6171C16.1341 13.9265 15.4393 13.9313 14.8552 13.6301L2.79617 7.40254C2.46568 7.23199 2.25707 6.89219 2.25453 6.5203C2.25203 6.14841 2.45602 5.80581 2.78416 5.6308L7.28604 3.2298C7.86542 2.92213 8.55882 2.91802 9.14181 3.21879Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8582 3.21879L2.79617 9.44439C2.46568 9.61494 2.25707 9.95474 2.25453 10.3266C2.25203 10.6985 2.45602 11.0411 2.78416 11.2161L7.28604 13.6171C7.86589 13.9265 8.56069 13.9313 9.14481 13.6301L21.2038 7.40254C21.5343 7.23199 21.7429 6.89219 21.7455 6.5203C21.748 6.14841 21.544 5.80581 21.2158 5.6308L16.714 3.2298C16.1346 2.92213 15.4412 2.91802 14.8582 3.21879Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.108 12.3438V16.2814C19.108 17.0205 18.7007 17.6994 18.0485 18.0471L12.9464 20.7713C12.358 21.085 11.652 21.085 11.0636 20.7713L5.96149 18.0471C5.30933 17.6994 4.90205 17.0205 4.90205 16.2814V12.3438"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 21.0059V12.1562"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

module.exports = {
  Product
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/menu/icons/product.js